import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

export const getZipData = () => {
    //@ts-ignore
    return axios.get(API_URL + `users-zip`, { headers: authHeader() });
};